// Load Dependencies
import React, { Component } from "react";
import * as Yup from "yup";

import "./ServerEdit.component.scss";
import Form from "../../../../../utils/forms/components/Form";
import { FormGridField } from "../../../../../utils/forms/components/FormGrid";

interface ServerEditState {
    creatingServer: any;
    isValid: boolean;
}

interface ServerEditProps {
    onClose?: (...args: any[]) => any;
    onConfirm?: (...args: any[]) => any;
    name: string;
    id: string | number;
    loading: boolean;
}

const nameSchema = Yup.string()
    .required("Field is required.")
    .max(20, "Max. 20 characters.")
    .matches(new RegExp(/^[\w\-\ \.]+$/), `Special characters not supported.`)
    .matches(
        new RegExp(/^(?!\.)([\w\-\ \.]?)+$/),
        `Should not start with a '.'`
    );

const nameForm: FormGridField[] = [
    {
        name: "name",
        fieldType: "input",
        fieldOptions: {
            id: "name",
            label: "Server Name",
            placeholder: "Server Name",
            inputType: "text"
        },
        validation: nameSchema,
        columnClass: "col-12",
        formSpacing: false
    }
];

export default class ServerEdit extends Component<
    ServerEditProps,
    ServerEditState
> {
    constructor(props) {
        super(props);

        this.state = {
            creatingServer: {
                name: props.name,
                id: props.id
            },
            isValid: false
        };
    }

    checkValidity = server => {
        return (
            server.id !== undefined &&
            server.id !== null &&
            server.name !== undefined &&
            server.name !== null &&
            server.name !== "" &&
            nameSchema.isValidSync(server.name) &&
            server.name.length <= 50
        );
    };

    onChangeName = e => {
        const newFormValues = {
            ...this.state.creatingServer,
            name: e.values.name
        };

        this.setState({
            creatingServer: newFormValues,
            isValid: this.checkValidity(newFormValues)
        });
    };

    submitServer = () => {
        if (this.state.isValid) {
            this.props.onConfirm(this.state.creatingServer);
        }
    };

    cleanBeforeClose = () => {
        this.setState({
            creatingServer: {
                name: null,
                id: null
            },
            isValid: false
        });
        this.props.onClose();
    };

    render = () => {
        return (
            <div id="edit-server">
                <div id="name" className="row">
                    <Form
                        fields={nameForm}
                        initialValues={{
                            name: this.state.creatingServer.name
                        }}
                        onChange={this.onChangeName}
                    />
                </div>
                <div className="editing-warning">
                    <i className="icon-exclamation-circle-light"></i>
                    Editing a Server will also generate a new
                    configuration. <b>Download</b> and <b>Upload</b>{" "}
                    it to the server in order to update info.
                </div>

                <div className="form-spacer" />
                <div className="row">
                    <div className="col-12">
                        <button
                            className={`red-btn edit-btn ${
                                this.props.loading ? "loading" : ""
                            }`}
                            disabled={!this.state.isValid || this.props.loading}
                            onClick={this.submitServer}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        );
    };
}
